import {getMultiAttributionFromEntry} from 'common/query-builder/query-builder/util';
import {MultiAttribution, MultiAttributionType} from 'common/widgets/multi-attribution-menu/types';
import {AttributionTypeToSpec} from 'common/widgets/multi-attribution-menu/constants';

import {Entry, isMetricEntry} from '../types';

export function getMultiAttributionLabel(entry: Entry, isMenuOpen: boolean): string {
  const multiAttribution = getMultiAttributionFromEntry(entry);
  if (multiAttribution) {
    return multiAttribution.type === MultiAttributionType.Custom
      ? multiAttribution.name
      : AttributionTypeToSpec[multiAttribution.type].label;
  } else {
    // We only want to show the placeholder text if it's open AND the user
    // doesn't have a selected attribution type already
    if (isMenuOpen) {
      return `Select value...`;
    }
    return ``;
  }
}

export function getMultiAttributionTitle(entry: Entry): string {
  const multiAttribution = getMultiAttributionFromEntry(entry);
  if (multiAttribution) {
    return AttributionTypeToSpec[multiAttribution.type].description;
  }
  return ``;
}

export function getUpdatedMultiAttribution(entry: Entry, multiAttribution: MultiAttribution): Entry {
  return isMetricEntry(entry)
    ? {...entry, measurement: {...entry.measurement, multiAttribution}}
    : ({...entry, multiAttribution} as Entry);
}
